export const pickup = {
  list: {
    title: '约球',
    eyebrow: '找球友',
    postPickup: '发布约球',
    getStarted: '找到合适的对手和球场',
    noPickups: '没有合适的约球？',
    noPickupsDesc: '试试搜索其他城市，或者自己发一场。',
    postFirst: '发布约球',
  },
  new: {
    title: '发布约球',
    format: '比赛类型',
    category: '比赛项目',
    rankedLabel: '积分赛',
    rankedTitle: 'Acework 积分赛',
    rankedHint: '比赛结果计入 Acework 官方评级和城市排行榜。双方都需在赛后确认比分。',
    eliteOnly: 'Elite',
    rankedEliteOnly: 'Acework 积分赛是 Elite 会员专属功能，升级后可发布积分赛。',
    date: '日期',
    time: '时间',
    duration: '时长',
    location: '球场位置',
    locationPlaceholder: '例如：日落网球俱乐部3号场地',
    city: '城市',
    ntrpMin: '最低水平',
    ntrpMax: '最高水平',
    costNotes: '费用与支付',
    costNotesPlaceholder: '10元/人，支付宝转账',
    notes: '其他说明',
    submit: '发布约球',
    pleaseFillFields: "请填写：",
      fillAllFields: '请填写所有必填字段',
    locationRequired: '球场位置为必填项',
    error: '创建约球失败',
    quotaExceeded: '你已达到本月的发布配额',
    upgradeToPro: '升级到Pro',
  },
  detail: {
    title: '约球详情',
    hostedBy: '主办方',
    host: '主办',
    dateTime: '时间',
    duration: '时长',
    players: '参加者',
    join: '加入约球',
    leave: '退出约球',
    cancel: '取消约球',
    full: '已满员',
    cancelled: '已取消',
    cancelConfirm: '确定要取消这场约球吗？',
    notFound: '未找到约球',
  },
  common: {
    singles: '单打',
    doubles: '双打',
    full: '满',
    joined: '已加入',
  },
};
